<div class="grid" *ngIf="show">
  <div class="grid__col-sm-6">
    <div class="inline-notifciation rel m-full-width">
      <div class="guts-p-full-1 error-notification">
        <p class="description">
          <df-icon icon="alert" class="color-error"></df-icon>
          {{ message }}
        </p>
      </div>
    </div>
  </div>
</div>
